import React, { MouseEventHandler } from 'react';
import { toast } from 'react-toastify';

import { Toast } from '@_shared/ui';

interface IProps {
	/** Toast의 왼쪽 아이콘 컴포넌트 */
	LeftIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

	/** Toast에 표시될 메시지 (필수) */
	message: React.ReactNode;

	/** Toast 버튼에 표시될 텍스트 */
	buttonText?: string;

	/** Toast 버튼 클릭 시 실행될 이벤트 핸들러 */
	onClick?: MouseEventHandler<HTMLDivElement>;

	/** Toast가 자동으로 닫히기까지의 시간 (기본값: 3000ms) */
	duration?: number;
}

/**
 * 사용자에게 Toast 알림을 생성하고 표시하는 함수
 */
export function toastGenerate({ LeftIcon, message, buttonText, onClick, duration = 3000 }: IProps) {
	toast(
		<Toast.Container>
			<Toast.TextContainer>
				{/* 왼쪽 아이콘이 제공된 경우 렌더링 */}
				{LeftIcon && <LeftIcon />}

				{/* 메인 메시지 표시 */}
				<Toast.Message>{message}</Toast.Message>
			</Toast.TextContainer>

			{/* 버튼 텍스트가 제공된 경우 버튼 렌더링 */}
			{buttonText && <Toast.Button onClick={onClick}>{buttonText}</Toast.Button>}
		</Toast.Container>,

		{
			/* Toast 자동 닫힘 시간 설정 */
			autoClose: duration,
		},
	);
}
